import React from 'react';

export default function HeroSection({ scrollTo }) {
    return (
        <section className="min-h-screen flex items-center justify-center py-24 md:py-[96px] px-4 md:px-6 relative overflow-hidden" id="top">
            {/* Background blobs */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                <div className="absolute w-[500px] h-[500px] rounded-full bg-primary-container/50 -top-[100px] -right-[100px] blur-[80px] animate-float" />
                <div className="absolute w-[400px] h-[400px] rounded-full bg-tertiary-container/50 -bottom-[50px] -left-[100px] blur-[80px] animate-float-d3" />
                <div className="absolute w-[300px] h-[300px] rounded-full bg-secondary-container/50 top-[40%] left-[30%] blur-[80px] animate-float-d5" />
            </div>

            <div className="relative z-10 max-w-[800px] text-center">
                {/* Title */}
                <h1 className="text-[clamp(2.5rem,7vw,5rem)] font-extrabold leading-[1.05] tracking-[-2px] md:tracking-[-2px] text-on-surface mb-6 animate-fade-up-1">
                    Hi, I'm <span className="gradient-text">Ramesh</span>.<br />
                    I build software.
                </h1>

                {/* Subtitle */}
                <p className="text-[clamp(1rem,2.5vw,1.35rem)] text-on-surface-variant leading-relaxed max-w-[600px] mx-auto mb-8 animate-fade-up-2">
                    Software developer, tech enthusiast, occasional writer, and motorcycle
                    enthusiast. I like solving problems with code and exploring places on two wheels.
                </p>

                {/* Actions */}
                <div className="flex flex-col xs:flex-row gap-4 justify-center items-center flex-wrap animate-fade-up-3">
                    <a
                        href="#projects"
                        className="inline-flex items-center gap-2 px-7 py-3 bg-primary text-on-primary rounded-full text-[0.9375rem] font-semibold tracking-wide shadow-1 hover:shadow-2 hover:brightness-[1.08] active:scale-[0.97] transition-all duration-200 ease-standard w-full xs:w-auto max-w-[280px] justify-center"
                        onClick={(e) => { e.preventDefault(); scrollTo('projects'); }}
                    >
                        <i className="fa-solid fa-shapes"></i> View Projects
                    </a>
                    <a
                        href="#contact"
                        className="inline-flex items-center gap-2 px-7 py-3 bg-secondary-container text-on-surface rounded-full text-[0.9375rem] font-semibold tracking-wide hover:shadow-1 hover:brightness-[0.96] active:scale-[0.97] transition-all duration-200 ease-standard w-full xs:w-auto max-w-[280px] justify-center"
                        onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
                    >
                        <i className="fa-solid fa-paper-plane"></i> Get in Touch
                    </a>
                </div>
            </div>
        </section>
    );
}
